import React from "react";
import { Drawer, Form, Select, Button, Spin, DatePicker, Space } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { useTranslation } from "react-i18next";

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(utc);

const SpecialCardsFilter = ({
  isDrawerOpen,
  setIsDrawerOpen,
  loading,
  onSave,
  onResetForm,
  filterValues,
  setFilterValues,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { cardTypes } = useSelector((state) => state.cardTypes);

  const onDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const handleFormSubmit = (values) => {
    const filterData = {
      cardTypeName: values.cardType,
      cardValidFrom: values.cardValidFrom ? dayjs(values.cardValidFrom).startOf('day').toISOString() : null,
      cardValidTo: values.cardValidTo ? dayjs(values.cardValidTo).endOf('day').toISOString() : null,
      bundleValidityFrom: values.bundleValidityFrom ? dayjs(values.bundleValidityFrom).startOf('day').toISOString() : null,
      bundleValidityTo: values.bundleValidityTo ? dayjs(values.bundleValidityTo).endOf('day').toISOString() : null,
    };
    
    setFilterValues(filterData);
    onSave(filterData);
  };
  const handleReset = () => {
    form.resetFields();
    setFilterValues({
      cardTypeName: null,
      cardValidFrom: null,
      cardValidTo: null,
      bundleValidityFrom: null,
      bundleValidityTo: null,
    });
    onResetForm();
    setIsDrawerOpen(false);
  };

  return (
    <Drawer
      title={t("specialCardScreen.filter.title")}
      placement="right"
      closable={false}
      onClose={onDrawerClose}
      width={400}
      open={isDrawerOpen}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          initialValues={{
            cardType: filterValues?.cardTypeName,
            cardValidFrom: filterValues?.cardValidFrom ? dayjs(filterValues.cardValidFrom) : null,
            cardValidTo: filterValues?.cardValidTo ? dayjs(filterValues.cardValidTo) : null,
            bundleValidityFrom: filterValues?.bundleValidityFrom ? dayjs(filterValues.bundleValidityFrom) : null,
            bundleValidityTo: filterValues?.bundleValidityTo ? dayjs(filterValues.bundleValidityTo) : null,
          }}
        >
          <Form.Item
            label={t("specialCardScreen.filter.cardType")}
            name="cardType"
          >
            <Select
              showSearch
              allowClear
              placeholder={t("specialCardScreen.filter.selectCardType")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {cardTypes?.map((cardType) => (
                <Select.Option key={cardType.id} value={cardType.name}>
                  {cardType.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={t("specialCardScreen.filter.cardValidFrom")}
            name="cardValidFrom"
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder={t("specialCardScreen.filter.selectDate")}
            />
          </Form.Item>

          <Form.Item
            label={t("specialCardScreen.filter.cardValidTo")}
            name="cardValidTo"
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder={t("specialCardScreen.filter.selectDate")}
            />
          </Form.Item>

          <Form.Item
            label={t("specialCardScreen.filter.bundleValidityFrom")}
            name="bundleValidityFrom"
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder={t("specialCardScreen.filter.selectDate")}
            />
          </Form.Item>

          <Form.Item
            label={t("specialCardScreen.filter.bundleValidityTo")}
            name="bundleValidityTo"
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder={t("specialCardScreen.filter.selectDate")}
            />
          </Form.Item>

          <div style={{ marginTop: 24 }}>
            <Space>
              <Button type="primary" htmlType="submit">
                {t("specialCardScreen.filter.apply")}
              </Button>
              <Button onClick={handleReset}>
                {t("specialCardScreen.filter.reset")}
              </Button>
              <Button onClick={onDrawerClose}>
                {t("specialCardScreen.filter.cancel")}
              </Button>
            </Space>
          </div>
        </Form>
      </Spin>
    </Drawer>
  );
};

export default SpecialCardsFilter;